class DetailsDisclosure extends HTMLElement {
  static activeDetails = null;

  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    if (this.hasAttribute('data-hover')) {
      this.mainDetailsToggle.addEventListener('mouseover', () =>
        this.onDetailsHover()
      );
      this.mainDetailsToggle.addEventListener('focusin', () =>
        this.onDetailsHover()
      );
      this.mainDetailsToggle.addEventListener(
        'mouseout',
        this.onDetailsMouseOut.bind(this)
      );
    }

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onDetailsMouseOut(event) {
    if (
      this.contains(event.relatedTarget) ||
      event.relatedTarget.tagName === 'HEADER'
    ) {
      return;
    }
    this.close();
  }

  onDetailsHover() {
    if (
      DetailsDisclosure.activeDetails &&
      DetailsDisclosure.activeDetails !== this.mainDetailsToggle
    ) {
      DetailsDisclosure.activeDetails.removeAttribute('open');
    }
    DetailsDisclosure.activeDetails = this.mainDetailsToggle;
    this.open();
  }

  onToggle() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', true);
    } else {
      this.animations.forEach((animation) => animation.cancel());
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', false);
    }
  }

  open() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.onToggle();
    }
  }

  close() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.onToggle();
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    )
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
